import { render, staticRenderFns } from "./VincularDepartamentos.vue?vue&type=template&id=63ec4cb7"
import script from "./VincularDepartamentos.vue?vue&type=script&lang=js"
export * from "./VincularDepartamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports